import {Switch} from '@mantine/core';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useEditCompanyAvailability from 'modules/companies/hooks/use-edit-company-availability';
import React from 'react';
import Loading from 'shared/migration-components/loading';
import styled from 'styled-components';

const CompanyHeader: React.FC = () => {
  const editCompanyAvailability = useEditCompanyAvailability();
  const {accessControl, permissionGroup} = useAccessControls();

  return (
    <Container>
      <Logo src={accessControl?.company?.logo} />
      <Column>
        <Title>{accessControl?.company?.name}</Title>
        <Description>{permissionGroup?.name}</Description>
      </Column>
      {!editCompanyAvailability.isLoading && (
        <Switch
          size="md"
          checked={accessControl?.company?.available}
          onChange={() => editCompanyAvailability.mutate(undefined)}
        />
      )}
      {editCompanyAvailability.isLoading && <Loading flex={false} />}
    </Container>
  );
};

export default CompanyHeader;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-left: 10px;
`;

const Column = styled.div`
  color: ${(props) => props.theme.colors.text};
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Logo = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
`;

const Title = styled.h3`
  line-height: 1;
  font-size: 12px;
`;

const Description = styled.span`
  font-size: 11px;
`;
